import { useQuery } from "@tanstack/react-query";
import { client } from "../../utils/axiosClient";

const queryConfig = {
  enabled: true,
  refetchInterval: 1800000,
  staleTime: Infinity,
  placeholderData: (prev: any) => prev,
};

export const useGetTenantMembers = () => {
  return useQuery({
    queryKey: ["tenantMembers"],
    queryFn: async () => {
      const response = await client.get("/tenant/members");
      return response.data;
    },
    ...queryConfig,
  });
};

export const useGetTenantDetails = () => {
  return useQuery({
    queryKey: ["tenantDetails"],
    queryFn: async () => {
      const response = await client.get("/tenant/tenant-details");
      return response.data;
    },
    ...queryConfig,
  });
};